// @flow
import * as React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import type { QueryProps } from 'gql/common'
import {
  type School,
  type SchoolWithDirector,
  type SchoolWithHandbook,
  SCHOOL_FIELDS_FRAGMENT,
  SCHOOL_WITH_DIRECTOR_FIELDS_FRAGMENT,
  SCHOOL_WITH_HANDBOOK_FIELDS_FRAGMENT,
} from 'gql/school'

export type SchoolData = School & { closedAt: string | null } & SchoolWithDirector &
  SchoolWithHandbook

export type Data = {
  school: SchoolData | null,
}

type Variables = {
  schoolSlug: string,
}

export type Props = QueryProps<Data> & { variables: Variables }

export const GQL = gql`
  query HandbookPageQuery($schoolSlug: String!) {
    school: schoolBySlug(slug: $schoolSlug) {
      closedAt
      ...SchoolFields
      ...SchoolWithDirectorFields
      ...SchoolWithHandbookFields
    }
  }

  ${SCHOOL_FIELDS_FRAGMENT}
  ${SCHOOL_WITH_DIRECTOR_FIELDS_FRAGMENT}
  ${SCHOOL_WITH_HANDBOOK_FIELDS_FRAGMENT}
`

export default function HandbookPageQuery(props: Props) {
  return <Query {...props} query={GQL} variables={props.variables} />
}
